<template>
  <div
    class="flex flex-col gap-6 lg:gap-12"
    :class="{
      'md:grid md:grid-cols-2': props.days?.length > 1,
      'max-w-xl mr-auto ml-auto': props.days?.length === 1,
    }"
  >
    <div
      v-for="(day, dayIndex) in props.days"
      :key="`D${dayIndex}`"
    >
      <div
        :class="[
          props.section.styles.boxed.value,
        ]"
      >
        <h3
          v-if="days.length > 1"
          class="mb-6"
          :class="[
            props.section.styles.textAlignment.value,
          ]"
        >
          {{ _upperFirst(getFormattedDate(day.date, {
            timezone: props.event?.general?.timezone,
            lang: props.section.lang.value.replace('_', ''),
            format: 'custom-fullMonthNoYear',
          })) }}
        </h3>
        <div
          v-for="(stage, stageIndex) in day.stages"
          :key="`S${stageIndex}`"
        >
          <div
            v-if="day.stages?.length > 1 && stage.program?.length"
            class="px-4 py-2 font-bold rounded bg-(bg-subtle) mb-6"
            :class="[
              props.section.styles.textAlignment.value,
            ]"
            v-html="sanitize(stage?.[props.section.lang.value]?.name)"
          />
          <PageAgendaBasicColumnsItem
            v-for="(programItem, programIndex) in stage.program"
            :key="`P${programIndex}`"
            :section="props.section"
            :event="props.event"
            :program-item="programItem"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
const props = defineProps({
  days: {
    type: Array,
    default: () => ([]),
  },

  section: {
    type: Object,
    default: () => ({}),
  },

  event: {
    type: Object,
    default: () => ({}),
  },
});
</script>
